import {
  RevendedorForm,
  Revendedor,
  RevendedorCreate,
} from '@core/models';

export function transformForResellerForm(reseller: Revendedor): RevendedorForm {

  return {
    name: reseller?.nombre,
    accountAssociated: reseller?.cuentasAsociadas.map((reseller)=>{
      return {
        ...reseller,
        id: reseller.cuentaId
      }
    }),
    email: reseller?.correo,
    phone: reseller?.telefono,
    status: reseller?.estado
  };
}

export function transformForUpdateReseller({
  name,
  accountAssociated,
  email,
  phone,
  password,
  status,
  storeId
}: RevendedorForm): RevendedorCreate {
  return {
    storeId,
    nombre: name,
    cuentasAsociadas: accountAssociated?.map((accountAssociated)=> accountAssociated['id'] as string),
    telefono: phone,
    estado: status,
    correo: email,
    contrasena: !!password ? password : undefined
  };
}

export interface ResellerWithDisplay extends Revendedor {
  displayName: string;
}

export function transformResellerWithDisplay(reseller: Revendedor): ResellerWithDisplay {
  return {
    ...reseller,
    displayName: `${reseller.nombre} - ${reseller.correo}`,
  };
}

export function transformResellersWithDisplay(resellers: Revendedor[]): ResellerWithDisplay[] {
  return resellers.map(transformResellerWithDisplay);
}
